import { Component } from '@angular/core';

@Component({
  selector: 'login-page',
  templateUrl: './login.component.html'
})
export class LoginComponent{}


// WEBPACK FOOTER //
// C:/Users/leoth/Desktop/Leo/Programming/Hackathons/Octocite/octocite/src/app/login.component.ts